<template>
    <b-card no-body>
        <v-table ref="table" :items-provider="provider" :fields="fields" name="total-feul-load" pagination="server" search :row-class="rowClassControl">
            <template #filters>
                <po-fuel-load-filter v-on:filter="filter($event)"></po-fuel-load-filter>
            </template>
            <template #additional-actions>
                <div class="row">
                    <div class="col-md-3">
                        <flat-pickr v-model="dateRange" class="form-control" :config="{ altInput: true, altFormat: 'd.m.Y', mode: 'range', dateFormat: 'Y-m-d', locale: 'tr' }" placeholder="Tarih Aralığı Seçiniz" />
                    </div>
                    <div class="col-md-auto col-12">
                        <button class="btn btn-success w-100" v-on:click="$refs.table.refresh()">Sorgula</button>
                    </div>
                </div>
            </template>
            <template #custom-html>
                <div class="row px-1 py-0">
                    <div class="col-md-3 mb-1">
                        <v-stats-box text="Toplam Tutar" variant="success" icon="currency_lira" :value="stats.TotalAmount" short-text="Vergi Dahil"></v-stats-box>
                    </div>
                    <div class="col-md-3 mb-1">
                        <v-stats-box text="Toplam Tutar" variant="danger" icon="currency_lira" :value="stats.TotalAmountWithoutTax" short-text="Vergi Hariç"></v-stats-box>
                    </div>
                    <div class="col-md-3 mb-1">
                        <v-stats-box text="Toplam Yakıt Litresi" variant="secondary" icon="oil_barrel" :value="stats.TotalQuantity"></v-stats-box>
                    </div>
                    <div class="col-md-3 mb-1">
                        <v-stats-box text="Toplam Yükleme Sayısı" variant="warning" icon="local_gas_station" :value="stats.Count"></v-stats-box>
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import FuelOperationApi from "@/api/fuel-operations";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/l10n/tr.js";
import moment from "moment";
import VStatsBox from "@/components/VStatsBox.vue";
import PoFuelLoadFilter from "./components/PoFuelLoadFilter";

export default {
    components: {
        BCard,
        flatPickr,
        VStatsBox,
        PoFuelLoadFilter,
    },
    data() {
        return {
            fields: [
                { name: "Filo Kodu", key: "FleetCode", thClass: "w-10", tdClass: "text-nowrap", sortable: true, sortKey: "FleetCode" },
                { name: "Filo Açıklama", key: "FleetDescription", thClass: "w-8", tdClass: "text-nowrap", sortable: true, sortKey: "FleetDescription" },
                { name: "Araç", key: "Plate", thClass: "w-8", sortable: true, sortKey: "Plate" },
                { name: "Kart No", key: "CardNo", thClass: "w-8", sortable: true, sortKey: "CardNo" },
                { name: "Tarih", key: "TransactionDate", thClass: "w-8", tdClass: "text-nowrap", sortable: true, sortKey: "TransactionDate" },
                { name: "Şehir", key: "CityName", thClass: "w-10", sortable: true, sortKey: "CityName" },
                { name: "İstasyon", key: "StationName", thClass: "w-13", tdClass: "text-nowrap", sortable: true, sortKey: "StationName" },
                { name: "Ürün", key: "ProductName", thClass: "w-10", tdClass: "text-nowrap", sortable: true, sortKey: "ProductName" },
                { name: "İşlem Tipi", key: "TransactionType", thClass: "w-10", tdClass: "text-nowrap", sortable: true, sortKey: "TransactionType" },
                { name: "Miktar (LT)", key: "Quantity", thClass: "w-8", sortable: true, sortKey: "Quantity" },
                { name: "Tutar (TL)", key: "Amount", thClass: "w-8", sortable: true, sortKey: "Amount" },
            ],
            dateRange: null,
            filteredData: {
                VehiclePlate: null,
                FiloCode: null,
            },
            stats: {
                TotalQuantity: null,
                TotalAmount: null,
                TotalAmountWithoutTax: null,
                Count: null,
            },
        };
    },
    created() {
        this.dateRange = this.c_month;
    },
    methods: {
        filter(filter) {
            this.filteredData = filter;
            this.$refs.table.refresh();
        },
        provider(data) {
            this.getStats();
            return FuelOperationApi.PetrolOfisi.Table({
                ...this.c_dates,
                VehiclePlate: this.filteredData.VehiclePlate,
                FiloCode: this.filteredData.FiloCode,
                PaginationRequest: data,
            });
        },
        getStats() {
            FuelOperationApi.PetrolOfisi.Stats({
                ...this.c_dates,
                VehiclePlate: this.filteredData.VehiclePlate,
                FiloCode: this.filteredData.FiloCode,
            }).then((res) => {
                this.stats = res.data.Data;
            });
        },
        rowClassControl(item, index) {
            if (item.StationName && item.StationName.includes("PETROL OFİSİ")) {
                return "table-success";
            }
            return null;
        },
    },
    computed: {
        c_dates() {
            return {
                StartDate: this.dateRange?.split(" - ")[0] || null,
                EndDate: this.dateRange?.split(" - ")[1] || null,
            };
        },
        c_month() {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"), moment(lastDay).format("YYYY-MM-DD")].join(" - ");
        },
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
